
import { computed, defineComponent, PropType, ref, Ref } from 'vue';
import CollageTileDefaultLayout from '@/shared/content/blocks/collage-layouts/CollageTileDefaultLayout.vue';
import CollageTileProductCategoryLayout
    from '@/shared/content/blocks/collage-layouts/CollageTileProductCategoryLayout.vue';
import CollageTileHorizontalSliderLayout
    from '@/shared/content/blocks/collage-layouts/CollageTileHorizontalSliderLayout.vue';
import { CollageTileLayoutOption, CollageTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CollageTile',
    components: { CollageTileDefaultLayout, CollageTileProductCategoryLayout, CollageTileHorizontalSliderLayout },
    props: {
        content: {
            type: Object as PropType<CollageTileModel>,
            required: true,
        },
    },
    setup(props) {
        const isReversedLayout: Ref<Boolean> = ref(props.content.layout === CollageTileLayoutOption.Reversed);
        const layoutComponent = computed(() => {
            const collageTileDefaultLayout = 'CollageTileDefaultLayout';

            switch (props.content.layout) {
            case CollageTileLayoutOption.Default:
            case CollageTileLayoutOption.Reversed:
                return collageTileDefaultLayout;
            case CollageTileLayoutOption.HorizontalSlider:
                return 'CollageTileHorizontalSliderLayout';
            case CollageTileLayoutOption.Product:
                return 'CollageTileProductCategoryLayout';
            default:
                return collageTileDefaultLayout;
            }
        });

        return {
            layoutComponent,
            isReversedLayout,
        };
    },
});

